import { useLocation } from 'react-router-dom';
import { TabsContainer } from '@/components/TabView/Tabs';

type Props = {
  paths?: {
    files: string;
    details: string;
  };
};

export const FolderTabViewContainer = ({
  paths = {
    files: `files`,
    details: `details`,
  },
}: Props) => {

  const location = useLocation();

  const currentTab = [
    paths.files,
    paths.details,
  ].find((tab) => location.pathname.endsWith(`/${tab}`));

  const items = [
    {
      label: 'Files',
      value: paths.files,
      to: paths.files,
    },
    {
      label: 'Details',
      value: paths.details,
      to: paths.details,
    },
  ];

  return (
    <TabsContainer currentTab={currentTab} items={items} />
  );
};